/**
 * World scale.
 *
 * Maps are authored on a tile grid, but the game is played in continuous
 * space with a camera sitting just behind the hero's shoulder. One tile has to
 * be big enough for a person to walk through a doorway without the camera
 * scraping the wall, hence two world units per tile and roughly human-sized
 * actors inside them.
 */

/** World units per map tile. */
export const TILE = 2;

/**
 * Scale applied to procedural characters on the field. `CharacterModel` is
 * about 0.95 units tall at scale 1, so this puts a person a little under a
 * tile wide and comfortably shorter than a wall.
 */
export const ACTOR_SCALE = 1.7;

/** Collision radius of a person, in world units. */
export const ACTOR_RADIUS = 0.45;

/** Convert a tile coordinate to the centre of that tile in world space. */
export function tileToWorld(tile: number): number {
  return tile * TILE;
}

/** Convert a world coordinate to the tile containing it. */
export function worldToTile(world: number): number {
  return Math.round(world / TILE);
}
